<!-- eslint-disable vue/valid-template-root -->
<template>
  <ZoneOfRelevanceTemplate
    :is-loyalty-fallback="isLoyaltyFallback"
    :is-desktop="isDesktop"
    :zor-cards="zorCards"
    :brand="brand"
    :carousel-title="sectionTitle"
    :is-open-in-new-tab="isOpenInNewTab"
  >
    <template #zor-slot>
      <component :is="loyaltyComponent" :full-width="isTablet || (isLoyaltyFallback && isDesktop)" />
    </template>
  </ZoneOfRelevanceTemplate>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { useEnvProps } from '@/stores/envProps';
import { useZoneOfRelevance } from '@/stores/zoneOfRelevance/zoneOfRelevance';
import ZoneOfRelevanceTemplate from '@nuxt-common/canvas-aem/app/components/zoneOfRelevance/ZoneOfRelevance';
import { IS_LOYALTY_FALLBACK } from '@/types/getters';
import { ZOR_CARD_SECTION_TITLES } from './constants';

import { userInfo } from '@/utils/userInfo';

const envPropsStore = useEnvProps();
const isDesktop = computed(() => envPropsStore.envProps?.headers?.deviceType === 'DESKTOP');
const isTablet = computed(() => envPropsStore.envProps?.headers?.deviceType === 'TABLET');
const brand = computed(() => envPropsStore?.envProps?.BRAND);
const isOpenInNewTab = computed(() => envPropsStore.envProps?.meta?.properties?.carouselOpenInNewTabEnabled);

const zoneOfRelevanceStore = useZoneOfRelevance();
const isLoyaltyFallback = computed(() => zoneOfRelevanceStore[IS_LOYALTY_FALLBACK]);
defineProps({
  zorCards: {
    type: Array,
    default: () => [],
  },
});
const isSignedIn = userInfo.isSignedIn();
const userStatus = isSignedIn ? 'signedIn' : 'notSignedIn';

const sectionTitle = computed(() => ZOR_CARD_SECTION_TITLES[brand?.value]?.[userStatus] || '');

const LoyaltyCard = brand.value === 'mcom' ? () => import('../mcom/LoyaltyCard') : () => import('../bcom/LoyaltyCard');

const loyaltyComponent = computed(() =>
  defineAsyncComponent({
    loader: LoyaltyCard,
    onError: () => {},
  }),
);
</script>
